import type { TOC } from '@ember/component/template-only';
import type Model from '@ember-data/model';
import UiCard from 'garaje/components/ui/card';
import SectionContent from 'garaje/components/visitors/questionnaires/form/section/content';
import SectionQuestions from 'garaje/components/visitors/questionnaires/form/section/questions';
import type QuestionnaireSection from 'garaje/models/questionnaire-section';
import type { LocaleKey } from 'garaje/utils/locale-options';
import type QuestionnaireValidator from 'garaje/utils/questionnaire-validator';

interface VisitorsQuestionnairesFormSectionSignature {
  Args: {
    canDeleteSection: boolean;
    deleteSection: (section: QuestionnaireSection) => void;
    defaultLocale: LocaleKey;
    onChange: (models: Model[]) => void;
    readOnly?: boolean;
    section: QuestionnaireSection;
    selectedLocale: LocaleKey;
    validator: QuestionnaireValidator;
  };
  Element: HTMLElement; // TS doesn't have HTMLSectionElement
}

export default <template>
  <section data-test-questionnaire-section={{@section.position}} ...attributes>
    <SectionContent
      @canDeleteSection={{@canDeleteSection}}
      @defaultLocale={{@defaultLocale}}
      @deleteSection={{@deleteSection}}
      @onChange={{@onChange}}
      @readOnly={{@readOnly}}
      @section={{@section}}
      @selectedLocale={{@selectedLocale}}
      class="rounded-b-none"
    />

    <UiCard class="transparent-page rounded-t-none">
      <SectionQuestions
        @defaultLocale={{@defaultLocale}}
        @onChange={{@onChange}}
        @readOnly={{@readOnly}}
        @section={{@section}}
        @selectedLocale={{@selectedLocale}}
        @validator={{@validator}}
      />
    </UiCard>
  </section>
</template> satisfies TOC<VisitorsQuestionnairesFormSectionSignature>;
